import "./walletmodal.css";
import Modal from "react-bootstrap/Modal";
import { useSelector } from "react-redux";
import DepositTab from "./deposit/DepositTab";
import WithdrawTab from "./withdraw/WithdrawTab";
import { useEffect, useState, useRef } from "react";

const WalletModal = (props) => {
  const startY = useRef(0);
  const cardRef = useRef(null);
  const [dragY, setDragY] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const isDarkMode = useSelector((state) => state.theme.darkMode);
  const activeTab = useSelector((state) => state.account?.activeTab);
  const [key, setKey] = useState(activeTab);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 641);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 641);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setKey(activeTab);
  }, [activeTab]);

  // Reset drag when modal opens
  useEffect(() => {
    if (props.modalShow) {
      setDragY(0);
      setIsDragging(false);
    }
  }, [props.modalShow]);

  // Swipe handlers
  const handleTouchStart = (e) => {
    if (!isMobile) return;
    startY.current = e.touches[0].clientY;
    setIsDragging(true);
  };

  const handleTouchMove = (e) => {
    if (!isMobile || !isDragging) return;
    const currentY = e.touches[0].clientY;
    const diff = currentY - startY.current;

    // Only allow dragging down
    if (diff > 0) {
      setDragY(diff);
    }
  };

  const handleTouchEnd = () => {
    if (!isMobile) return;
    setIsDragging(false);

    // If dragged more than 150px, close the modal
    if (dragY > 150) {
      onClose();
    }
    setDragY(0);
  };

  const onClose = () => {
    props.onHide();
    setTimeout(() => {
      setKey("deposit");
    }, 1000);
  };

  const backdropOpacity = isMobile ? Math.max(0, 1 - dragY / 300) : 1;

  return (
    <Modal
      centered={!isMobile}
      {...props}
      backdrop={true}
      aria-labelledby="wallet-modal-title"
      className={`custom-wallet-modal-wrapper ${
        isMobile ? "mobile-bottom-sheet" : ""
      } ${isDarkMode ? "dark" : "light"}`}
      animation={false}
      style={isMobile ? { "--backdrop-opacity": backdropOpacity } : {}}
    >
      <div
        ref={cardRef}
        className={`custom-wallet-modal-content ${isDarkMode ? "dark" : "light"}`}
        style={{
          backgroundColor: isDarkMode ? "#1A1A1A" : "#ffffff",
          ...(isMobile
            ? {
                transform: `translateY(${dragY}px)`,
                transition: isDragging ? "none" : "transform 0.3s ease-out",
              }
            : {}),
        }}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {/* Swipe Handle - Only on mobile */}
        {isMobile && (
          <div
            ref={(el) => {
              if (el)
                el.style.setProperty("background", "#1A1A1A", "important");
            }}
            className="swipe-handle-container"
          >
            <div className="swipe-handle" />
          </div>
        )}

        <Modal.Header
          className="wallet-modal-head-fixed p-4"
          closeVariant={isDarkMode ? "white" : "grey"}
        >
          <div className="custom-tab-buttons w-100">
            <button
              className={`tab-button-fixed ${
                key === "deposit" ? "tab-active-fixed" : ""
              } ${isDarkMode ? "tab-dark-fixed" : "tab-light-fixed"}`}
              onClick={() => setKey("deposit")}
            >
              Deposit
            </button>
            <button
              className={`tab-button-fixed ${
                key === "withdraw" ? "tab-active-fixed" : ""
              } ${isDarkMode ? "tab-dark-fixed" : "tab-light-fixed"}`}
              onClick={() => setKey("withdraw")}
            >
              Withdraw
            </button>
          </div>
        </Modal.Header>

        <Modal.Body
          className="wallet-modal-body-fixed"
          style={{
            backgroundColor: isDarkMode ? "#1A1A1A" : "#ffffff",
            padding: 0,
          }}
        >
          <div
            className="tab-content-wrapper-fixed"
            style={{
              backgroundColor: isDarkMode ? "#1A1A1A" : "#ffffff",
            }}
          >
            {key === "deposit" && <DepositTab />}
            {key === "withdraw" && (
              <WithdrawTab
                hidemodal={props.onHide}
                pendingItems={props.pendingItems}
                setConfirmOpen={props.setConfirmOpen}
                setPendingItems={props.setPendingItems}
              />
            )}
          </div>
        </Modal.Body>

        {isMobile && (
          <div
            ref={(el) => {
              if (el)
                el.style.setProperty("background", "#1A1A1A", "important");
            }}
            className="swipe-handle-container-bottom swipe-handle-container-bottom-wm"
          >
            <div className="swipe-handle-bottom" />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default WalletModal;
